export default __webpack_public_path__ + "static/media/mercedes.908c3cf0.svg";